import { CancellationInfoProps } from 'models/appointment.types';

type CancelInfo = CancellationInfoProps;

export const CANCEL_REASON_LABELS: Record<string, string> = {
  AccountCancelled: 'account cancellation',
  DowngradeToFlexCare: 'plan change',
  ProgramDowngraded: 'plan change'
};

const CANCEL_REASON_DETAIL_MESSAGES: Record<string, string> = {
  AccountCancelled: 'This appointment was automatically cancelled due to account cancellation.',
  DowngradeToFlexCare: 'This appointment was automatically cancelled due to a plan change.',
  ProgramDowngraded: 'This appointment was automatically cancelled due to a plan change.'
};

const CANCEL_REASON_TOAST_MESSAGES: Record<string, string> = {
  AccountCancelled: 'Your appointment has been cancelled due to account cancellation.',
  DowngradeToFlexCare: 'Your appointment has been cancelled due to a change in your plan.',
  ProgramDowngraded: 'Your appointment has been cancelled due to a change in your plan.'
};

const DEFAULT_AUTO_MESSAGE = 'This appointment was automatically cancelled.';
const DEFAULT_STAFF_MESSAGE = 'This appointment has been cancelled.';

export const getReasonCode = (reason?: CancelInfo['reason']): string | undefined =>
  reason?.staff ?? reason?.automatic;

export const getCancellationMessage = (cancelationInfo?: CancelInfo): string => {
  if (!cancelationInfo) {
    return DEFAULT_STAFF_MESSAGE;
  }

  const reasonCode = getReasonCode(cancelationInfo.reason);
  if (reasonCode && CANCEL_REASON_DETAIL_MESSAGES[reasonCode]) {
    return CANCEL_REASON_DETAIL_MESSAGES[reasonCode];
  }

  if (cancelationInfo.isAutomated) {
    return DEFAULT_AUTO_MESSAGE;
  }

  return DEFAULT_STAFF_MESSAGE;
};

export const getCancellationToastMessage = (cancelationInfo?: CancelInfo): string => {
  const reasonCode = getReasonCode(cancelationInfo?.reason);

  if (reasonCode && CANCEL_REASON_TOAST_MESSAGES[reasonCode]) {
    return CANCEL_REASON_TOAST_MESSAGES[reasonCode];
  }
  if (cancelationInfo?.isAutomated) {
    return 'Your appointment has been automatically cancelled.';
  }

  return 'Your appointment has been cancelled.';
};
